import {
  isAfter,
  isBefore,
  isWithinInterval,
  parseISO,
  startOfDay,
} from 'date-fns';

import type { IAccount, IMeter } from 'common/src/types/interfaces';

export const isActiveAccount = (
  account: Partial<IAccount> | undefined,
): boolean => {
  if (!account || !account.isActive) {
    return false;
  }

  const { serviceEndDate, serviceStartDate } = account;
  const currentDate = new Date();

  if (serviceStartDate && serviceEndDate)
    return isWithinInterval(currentDate, {
      start: parseISO(serviceStartDate),
      end: parseISO(serviceEndDate),
    });
  if (serviceStartDate)
    return isAfter(startOfDay(currentDate), parseISO(serviceStartDate));
  if (serviceEndDate)
    return isBefore(startOfDay(currentDate), parseISO(serviceEndDate));

  return true;
};

export const isActiveMeter = (meter: Partial<IMeter> | undefined): boolean => {
  if (!meter || !meter.isActive) {
    return false;
  }

  return (
    !meter.inactiveDate || isAfter(parseISO(meter.inactiveDate), new Date())
  );
};
